<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title>
                    <strong>
                        Admission Age Configuration
                    </strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row justify="center" dense class="no-display">
                <v-col cols="12" sm="2" md="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required @click="putnull()" v-model="sel_ay_data"
                        return-object :items="ay_std_div_list" item-text="ay" label="Select Academic Year" outlined
                        persistent-hint hint="Please select academic year" />
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="sel_ay_data">
                    <v-btn class="mt-6 button" @click="onload()">Fetch / Generate</v-btn>
                </v-col>
            </v-row>
        </v-card>
        <v-card class="box" v-if="std_age_config_list!=''">
            <v-col cols="12" sm="12" md="12">
                <v-simple-table dense class="elevation-1" fixed-header height="500px">
                    <thead>
                        <tr>
                            <th class="">
                                <center>Sr. No.</center>
                            </th>
                            <th class="">
                                <center>Standard</center>
                            </th>
                            <th>
                                <center> From Date</center>
                            </th>
                            <th>
                                <center>To Date</center>
                            </th>
                            <th>
                                <center>Save / Update</center>
                            </th>
                        </tr>
                    </thead>
                    <tbody style="overflow-y: scroll;">
                        <tr v-for="(s,index) in std_age_config_list" :key="s.sid">
                            <td>{{index+1}}</td>
                            <td>{{s.standard}}</td>
                            <td>
                                <input style="width: 200px;" id="datePickerId" type="date" v-model="s.from_date" />
                            </td>
                            <td>
                                <input style="width: 200px;" id="datePickerId" type="date" v-model="s.to_date" />
                            </td>
                            <td>
                                <v-btn small class="button" :disabled="s.from_date == null || s.to_date == null"
                                    @click="saveSingleAgeConfig(s)">Save / Update</v-btn>
                            </td>
                        </tr>
                    </tbody>
                </v-simple-table>
                <center><v-btn :loading="loader" small @click="saveAgeConfig()" class="button">Save / Update</v-btn>
                </center>
            </v-col>
        </v-card>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </div>
</template>
<script>
    import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed

export default {
    components: {
        Breadcrumbs,
    },
        data() {
            return {
                snackbar_msg: "",
                color: "",
                snackbar: false,
                overlay: false,
                search: null,
                ay_std_div_list: null,
                sel_ay_data: null,
                ay_id: null,
                std_age_config_list: [],
                sem_list: [],
                loader: false,
                std_copy_list: [],
                from_std: null,
                to_std: [],
                copy_offer_btn_load: false,
                // extraBreadcrumbItems: [


                // ],
                // breadcrumbClass: "breadcrumb-style1",
            };
        },
        methods: {
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            saveAgeConfig() {
                this.loader = true;
                const data = {
                    ay: this.sel_ay_data.ay_id,
                    age_config: this.std_age_config_list,
                };
                axios
                    .post("/Admission/saveAllAgeConfig", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.showSnackbar("#4caf50", " Save Successfully..."); // show snackbar on success
                            this.onload();
                            this.loader = false;
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                            this.loader = false;
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                        this.loader = false;
                    })
                    .finally(() => {
                        this.loader = false;
                    });
            },
            saveSingleAgeConfig(sid, header) {
                const data = {
                    ay: this.sel_ay_data.ay_id,
                    sid: sid,
                };
                axios
                    .post("/Admission/saveSingleAgeConfig", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.showSnackbar("#4caf50", " Save Successfully..."); // show snackbar on success
                            this.onload();
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => {});
            },
            onload() {
                const data = {
                    ay: this.sel_ay_data.ay_id,
                };
                this.overlay = true;
                axios
                    .post("/Admission/getAgeConfig", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.std_age_config_list = res.data.std_age_config_list;
                            this.overlay = false;
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                        this.overlay = false;
                    })
                    .finally(() => {
                        this.overlay = false;
                    });
            },
            main() {
                axios
                    .post("/commonAPI/get_ay_std_div")
                    .then((res) => {
                        this.ay_std_div_list = res.data.data;
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => {});
            },
        },
        mounted() {
            this.main();
        },
    };
</script>
<style scoped>
    input[type="date"] {
        width: 30%;
        display: inline-block;
        padding: 0.3rem;
        border: 1px solid gray;
        border-radius: 30px;
        box-sizing: border-box;
        padding-top: none !important;
        margin-top: none !important;
    }
    .text-color {
        font-weight: bold;
        color: red;
    }
    tr,
    td,
    th {
        border: 1px solid #ccc;
        text-align: center;
    }
    tr,
    tbody {
        border-bottom: 1px solid #ccc;
        border: 1px solid #ccc;
    }
    td {
        margin: 0.3rem !important;
        padding: 0.4rem !important;
    }
    @media (min-width: 320px) {
        td,
        th {
            display: table-cell !important;
        }
        td + td,
        th + th {
            width: auto;
        }
    }
    v-simple-table {
        white-space: nowrap !important;
        text-align: center;
    }
    .mytable /deep/ thead th {
        background: #0f2027 !important; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
</style>
